import { render, staticRenderFns } from "./PeerReviewPanelAdmin.vue?vue&type=template&id=00458de6&scoped=true&"
import script from "./PeerReviewPanelAdmin.vue?vue&type=script&lang=js&"
export * from "./PeerReviewPanelAdmin.vue?vue&type=script&lang=js&"
import style0 from "./PeerReviewPanelAdmin.vue?vue&type=style&index=0&id=00458de6&lang=scss&scoped=true&"
import style1 from "./PeerReviewPanelAdmin.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00458de6",
  null
  
)

export default component.exports